import PropTypes from 'prop-types'
import {
  NotificationMenuLabelContainer,
  NotificationMenuLabel,
  NotificationSubMenuLabel,
  NotificationMenuLabelContainerNoPadding
} from '../../../styled-components'
import { ChevronRight } from '../../../../../atoms/icons/essentials'
import { iconSizeOptions } from '../../../../../atoms/icons/icons-sizes'
import { FormattedMessage, useIntl } from 'react-intl'
import ContextMenuComponent from '../../../../context-menu'
import {
  contextMenuAlignOptions,
  contextMenuSideOptions,
  contextMenuArrowAlignmentOptions
} from '../../../../context-menu/constants'

const NotificatationFooter = ({
  handleSelectEmailNotification = () => {},
  defaultSelectedValue = []
}) => {
  const { formatMessage } = useIntl()
  return (
    <ContextMenuComponent.Root
      style={{ width: '100%' }}
      handleSelect={(item) => handleSelectEmailNotification(item[0])}
      defaultValue={defaultSelectedValue}
      isSingle
    >
      <ContextMenuComponent.Trigger>
        <NotificationMenuLabelContainer>
          <NotificationMenuLabel>
            <FormattedMessage id="email_notification" />
          </NotificationMenuLabel>

          <ChevronRight size={iconSizeOptions['ICON-S']} />
        </NotificationMenuLabelContainer>
      </ContextMenuComponent.Trigger>
      <ContextMenuComponent.List
        align={contextMenuAlignOptions.START}
        side={contextMenuSideOptions.TOP}
        arrowAlignment={contextMenuArrowAlignmentOptions.END}
        sideXOffset={15}
        sideYOffSet={-10}
        width="240px"
        arrow
      >
        <NotificationMenuLabelContainerNoPadding>
          <NotificationSubMenuLabel>
            <FormattedMessage id="notification_email_preference" />
          </NotificationSubMenuLabel>
        </NotificationMenuLabelContainerNoPadding>

        <ContextMenuComponent.Item
          id="never"
          title={formatMessage({ id: 'never' })}
          secondaryText={formatMessage({ id: 'notification_neverSubText' })}
          data-api="Never"
        />

        <ContextMenuComponent.Item
          id="periodically"
          title={formatMessage({ id: 'notification_periodicallyTitle' })}
          secondaryText={formatMessage({
            id: 'notification_periodicallySubText'
          })}
          data-api="Periodically"
        />

        <ContextMenuComponent.Item
          id="instantly"
          title={formatMessage({ id: 'notification_instantlyTitle' })}
          secondaryText={formatMessage({ id: 'notification_instantlySubText' })}
          data-api="Instantly"
          style={{
            paddingBottom: '0.5rem'
          }}
        />
        <ContextMenuComponent.Divider />
      </ContextMenuComponent.List>
    </ContextMenuComponent.Root>
  );
}

NotificatationFooter.propTypes = {
  handleSelectEmailNotification: PropTypes.func,
  defaultSelectedValue: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string })
  )
}

export default NotificatationFooter
